import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_PUBLIC_HOLIDAYS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetPublicHolidaysRequestPayload, GetPublicHolidaysResult } from '../types/getPublicHoliday.type';

export const TAG_MEDREFILL_PUBLIC_HOLIDAYS = 'getPublicHolidays';
export const getPublicHolidays = (builder: BuilderType) =>
  builder.query<GetPublicHolidaysResult, GetPublicHolidaysRequestPayload>({
    providesTags: [TAG_MEDREFILL_PUBLIC_HOLIDAYS],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_MEDREFILL_PUBLIC_HOLIDAYS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPublicHolidaysResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
